export default __webpack_public_path__ + "static/media/portfolio1.f5e72352.jpg";